import TyreCatalogFilterOptionsStore from './tyre';
import WheelCatalogFilterOptionsStore from './wheel';
import {types as productTypes} from '../../../_constants/product/types';

function getCatalogFilterOptionsStoreByProductType(productType) {
    if (productType === productTypes.WHEEL) {
        return WheelCatalogFilterOptionsStore;
    }
    if (productType === productTypes.TYRE_CAR || productType === productTypes.TYRE_MOTO) {
        return TyreCatalogFilterOptionsStore;
    }
}

export {getCatalogFilterOptionsStoreByProductType};
